import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Sport, SportsResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class SportsDataService {

  private uri: string = `${environment.apiUrl}sports`;
  private cacheKey: string = 'sports.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getSport(id: number): Observable<Sport|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getSports(parameters: {[param: string]: string | string[]}): Observable<SportsResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addSport(data: Sport): Observable<Sport|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addSports(data: Sport[]): Observable<Sport[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateSport(data: Sport): Observable<Sport|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateSports(data: Sport[]): Observable<Sport[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchSport(data: Sport): Observable<Sport|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchSports(data: Sport[]): Observable<Sport[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteSport(data: Sport): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteSports(data: Sport[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((sport) => {
      ids.push(sport.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
